import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "pay-salary-modal"
}
const _hoisted_2 = { class: "modal-dialog mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header pb-0 border-0 justify-content-between align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Preview salary report before payment ?", -1)
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-5 mt-5 text-start" }, " You can preview the user's salary report for the period or proceed and mark it as payed. ", -1)
const _hoisted_9 = { class: "d-flex mt-10 justify-content-end" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "spinner-border me-2 spinner-border-sm"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Preview salary report ")
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "spinner-border me-2 spinner-border-sm"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Pay ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-sm btn-icon btn-active-color-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal(false, null)))
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              disabled: _ctx.loading,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previewSalaryReport && _ctx.previewSalaryReport(...args))),
              class: "h-40px d-flex justify-content-center me-5 align-items-center btn btn-primary"
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                : _createCommentVNode("", true),
              _hoisted_12
            ], 8, _hoisted_10),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handlePayButton && _ctx.handlePayButton(...args))),
              disabled: _ctx.loading,
              class: "h-40px d-flex justify-content-center align-items-center btn btn-success"
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                : _createCommentVNode("", true),
              _hoisted_15
            ], 8, _hoisted_13)
          ])
        ])
      ])
    ])
  ]))
}